import { action, computed } from "@ember/object"
import type ObjectProxy from "@ember/object/proxy"
import { inject } from "@ember/service"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import type { ArticleSliceExplainer } from "@shared/models/prismic-article"
import type { PrismicDoc } from "@shared/models/prismic-explainer"
import findDocument from "cc-frontend/helpers/find-document"
import type EmberStore from "cc-frontend/services/ember-store"
import { toLeft, toRight } from "ember-animated/transitions/move-over"
import styles from "./explainer.module.css"

interface Args {
  slice: ArticleSliceExplainer
}
export default class KbPrismicExplainerComponent extends Component<Args> {
  readonly styles = styles

  // Services
  @inject("ember-store") store!: EmberStore

  // Props
  @tracked featuredStepIndex = 0

  rules({ oldItems, newItems }) {
    let oldItem = oldItems[0]
    let newItem = newItems[0]
    if (oldItem && newItem && oldItem.index < newItem.index) {
      return toLeft
    } else {
      return toRight
    }
  }

  // CPs and getters
  @findDocument("args.slice.primary.explainer.id", "prismic-doc")
  prismicDoc!: ObjectProxy<PrismicDoc>

  @computed("prismicDoc.isFulfilled")
  get totalSteps() {
    return this.prismicDoc?.content?.attributes.data.body.length || 0
  }

  @computed("prismicDoc.isFulfilled", "featuredStepIndex")
  get featuredStep() {
    return Object.assign(
      {},
      this.prismicDoc?.content?.attributes.data.body[this.featuredStepIndex],
      { index: this.featuredStepIndex }
    )
    // let slices = get(this, "prismicDoc.content.attributes.data.body") //[this.featuredStepIndex]
    // return isArray(slices) ? slices[this.featuredStepIndex] : null
  }

  // Actions
  @action
  next() {
    if (this.featuredStepIndex !== this.totalSteps - 1) {
      this.featuredStepIndex++
    }
  }

  @action
  back() {
    if (this.featuredStepIndex !== 0) {
      this.featuredStepIndex--
    }
  }
}
